const layouts = {
  full: 'full',
  overview: 'overview',
};

export default layouts;
